// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZF-z","hovered":"_F-z","hoverImage":"aG-z","mainImage":"bG-z","imageNoBackground":"cG-z","fullSizeImage":"dG-z"};